import React, { useState, useEffect } from "react";
import "../Footer/footer.css";
import { Row, Col, Layout, Menu } from 'antd';
import { LinkedinOutlined, FacebookOutlined, TwitterOutlined, GithubOutlined } from '@ant-design/icons';
import { Link, useNavigate } from "react-router-dom";
const { Footer } = Layout;

const footerStyle = {
  textAlign: "center",
  color: "#fff",
  backgroundColor: "#000",
  padding: "50px 110px 20px 110px",
};

const menuStyle = {
  backgroundColor: "transparent",
  border: "none",
  color: "#fff",
  flex: 1,
  justifyContent: "flex-start",
};

function FooterComponent() {
  const [screenSize, setScreenSize] = useState("desktop");
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width <= 768) {
        setScreenSize("mobile");
      } else if (width <= 1024) {
        setScreenSize("tablet");
      } else {
        setScreenSize("desktop");
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const responsiveFooterStyle = {
    ...footerStyle,
    padding: screenSize === "mobile" ? "30px 20px 20px 20px" : footerStyle.padding,
  };

  const menuItems = [
  {
    key: "home",
    label: <Link to="/">Home</Link>,
  },
  {
    key: "features",
    label: <Link to="/features">Features</Link>,
  },
  {
    key: "pricing",
    label: <Link to="/pricing">Pricing</Link>,
  },
  {
    key: "contact",
    label: <Link to="/contact">Contact</Link>,
  },
];

  const menuItems2 = [
    {
      key: "services",
      // icon: <HomeOutlined />,
      label: "Services",
    },
    {
      key: "about",
      // icon: <InfoCircleOutlined />,
      label: "About",
    },
    {
      key: "privacy_policy",
      // icon: <UserOutlined />,
      label: "Privacy Policy",
    },
    {
      key: "disclaimer",
      // icon: <SettingOutlined />,
      label: "Disclaimer",
    },
  ];

  const handleMenuClick = (e) => {
    console.log("Menu item clicked:", e.key);
    if (e.key === "pricing") {
      navigate(`/pricing`);
    } else if (e.key === "features") {
      navigate(`/features`);
    } else if (e.key === "contact") {
      navigate(`/contact`);
    } else {
      navigate(`/`);
    }
  };

  return (
    <Footer style={responsiveFooterStyle}>
      <Row>
        <Col span={screenSize === "mobile" ? 24 : 5} style={{ textAlign: screenSize === "mobile" ? "center" : "left", marginBottom: screenSize === "mobile" ? "30px" : "0" }} >
          {/* <h1>Optix360</h1> */}
          <img src={require("../../assets/images/footerlogo.png")} alt="Optix360" style={{ width: "50 px", height: "50px", display: screenSize === "mobile" ? "block" : "inline-block", margin: screenSize === "mobile" ? "0 auto 10px auto" : "0 0 10px 0" }} />
          {screenSize !== "tablet" && (
            <p style={{ fontSize: "14px", lineHeight: "24px" }}>The content, features, and materials presented by Optix360 are fully protected under copyright laws. This includes, but is not limited to, text, graphics, logos, designs, software, videos, and any other creative assets associated with Optix360. As the exclusive owner of these intellectual properties, Optix360 retains all rights, ensuring the integrity and originality of our platform..</p>
          )}
        </Col>
        <Col span={screenSize === "mobile" ? 24 : 4} style={{ textAlign: screenSize === "mobile" ? "center" : "left", marginLeft: screenSize === "mobile" ? "0" : "50px", marginBottom: screenSize === "mobile" ? "30px" : "0" }}>
          <h1>Menu</h1>
          <Menu
            mode="vertical"
            items={menuItems}
            onClick={handleMenuClick}
            style={menuStyle}
            theme="dark"
          />
        </Col>
        <Col span={screenSize === "mobile" ? 24 : 4} style={{ textAlign: screenSize === "mobile" ? "center" : "left", marginLeft: screenSize === "mobile" ? "0" : "50px", marginBottom: screenSize === "mobile" ? "30px" : "0" }}>
          <h1>Links</h1>
          <Menu
            mode="vertical"
            items={menuItems2}
            onClick={handleMenuClick}
            style={menuStyle}
            theme="dark"
          />
        </Col>
        <Col span={screenSize === "mobile" ? 24 : 5} style={{ textAlign: screenSize === "mobile" ? "center" : "left", marginLeft: screenSize === "mobile" ? "0" : "50px" }}>
          <h1>Contact</h1>
          <p style={{ fontSize: "14px", lineHeight: "24px" }}>Email: info@optix360.com</p>
          <p style={{ fontSize: "14px", lineHeight: "24px" }}>Phone: +92 307 5487676</p>
          <p style={{ fontSize: "14px", lineHeight: "24px" }}>Address: I-14, Street 30, Islamabad, Pakistan</p>

          <Row gutter={16} style={{ flexDirection: screenSize === "mobile" ? "column" : "row", alignItems: screenSize === "mobile" ? "center" : "flex-start" }}>
            {/* <Col span={isMobile ? 24 : 7} style={{ textAlign: isMobile ? "center" : "left", marginBottom: isMobile ? "10px" : "0" }}>
              <h2 style={{ fontSize: "13px", lineHeight: "24px" }}>
                Social Media:
              </h2>
            </Col> */}
            <Col span={screenSize === "mobile" ? 24 : 17} style={{ textAlign: screenSize === "mobile" ? "center" : "left" }}>
              <div style={{ display: "flex", justifyContent: screenSize === "mobile" ? "center" : "flex-start", gap: "16px" }}>
                <LinkedinOutlined style={{ fontSize: "24px", lineHeight: "24px" }} />
                <FacebookOutlined style={{ fontSize: "24px", lineHeight: "24px" }} />
                <TwitterOutlined style={{ fontSize: "24px", lineHeight: "24px" }} />
                <GithubOutlined style={{ fontSize: "24px", lineHeight: "24px" }} />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row style={{ borderTop: "1px solid #fff", marginTop: "20px", paddingTop: "10px", flexDirection: screenSize === "mobile" ? "column" : "row" }}>
        <Col span={screenSize === "mobile" ? 24 : 12} style={{ textAlign: screenSize === "mobile" ? "center" : "left", marginBottom: screenSize === "mobile" ? "10px" : "0" }}>
          <p style={{ fontSize: "14px", lineHeight: "24px" }}>Copyright © 2025 Optix360. All rights reserved.</p>
        </Col>
        <Col span={screenSize === "mobile" ? 24 : 12} style={{ textAlign: screenSize === "mobile" ? "center" : "right" }}>
          <p style={{ fontSize: "14px", lineHeight: "24px" }}>Powered by <a href="https://www.mayaartech.com" target="_blank" rel="noopener noreferrer" style={{ color: "#fff" }}>Mayaar Tech</a></p>
        </Col>
      </Row>
    </Footer>
  )
}

export default FooterComponent;